import { useEffect, useState } from "react";
import api from "../lib/api";

export const PartnersCarousel = () => {
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    api.get("/partners").then((r) => setLogos(r.data || [])).catch(() => setLogos([]));
  }, []);

  if (logos.length === 0) return null;
  const loop = Array(Math.max(2, Math.ceil(12 / logos.length) * 2)).fill(logos).flat();

  return (
    <section className="border-b border-white/10 bg-[#0B0D14] py-4 sm:py-8 overflow-hidden" data-testid="partners-carousel">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 mb-3 sm:mb-5">
        <div className="label-caps" style={{ color: "#39FF14", letterSpacing: "0.28em" }}>Parceiros</div>
      </div>
      <div className="partners-mask">
        <div className="partners-track" style={{ animationDuration: `${loop.length * 0.3}s` }}>
          {loop.map((l, i) => (
            <div key={`${l.id}-${i}`} className="partner-logo" data-testid={`partner-logo-${i}`}>
              <img src={l.url} alt="Parceiro" loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersCarousel;
